<script setup>
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";

const portalContentAndDesignStore = usePortalContentAndDesignStore();
</script>

<template>
    <div class="space-y-4">
        <text-field
            label="Title"
            name="portal_signup_title"
            type="text"
            v-model="portalContentAndDesignStore.translationSettings.portal_signup_title"
        >
        </text-field>

        <text-editor
            name="portal_signup_description"
            :text="portalContentAndDesignStore.translationSettings.portal_signup_description"
            @input="(newValue) => { portalContentAndDesignStore.translationSettings.portal_signup_description = newValue }"
        >
        </text-editor>

        <radio-group-inline
            label="Branding"
            name="program_signup_page_branding_type"
            v-model="portalContentAndDesignStore.signupPageSettings.signup.program_signup_page_branding_type"
            :options="[
                          { value: 'none', label: 'None'},
                          { value: 'symbol', label: 'Symbol'},
                          { value: 'logo', label: 'Logo'}
                      ]">
          <template #note>
            Select which image to display above the signup title.
          </template>
        </radio-group-inline>
    </div>
</template>
